module.exports = __webpack_public_path__ + "img/Assets-03.cfdb9a66.svg";